// extracted by mini-css-extract-plugin
export var cardIcon = "_5f-4";
export var checkboxCard = "_5f-0";
export var checkboxCardSelected = "_5f-3";
export var disabled = "_5f-1";
export var outerBorder = "_5f-2";
export var spacerMedium = "_5f-7";
export var spacerSmall = "_5f-6";
export var spacerXsmall = "_5f-5";